import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { HotToastRef } from '@ngxpert/hot-toast';
import { Icon } from '@tvd/design-system/icon';

@Component({
  selector: 'tvd-offline-toast',
  imports: [Icon],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="flex items-center gap-3 px-1">
      <tvd-icon icon="cloud_off" size="sm" />
      <p class="text-sm">{{ message }}</p>
    </div>
  `,
})
export class OfflineToast {
  readonly #toastRef = inject(HotToastRef);

  get message(): string {
    return (this.#toastRef.data?.message as string) ?? 'You are offline';
  }
}
